export default {
    acquiring_device: "Төлөм кабыл алуу түзмөгү",
    add_expense: "Чыгымдарды кошуңуз",
    add_income: "Киреше кошуу",
    advance_noun: "Аванс",
    all_pay_methods: "Бардык төлөө ыкмалары",
    bank_terminal: "Банк терминалы",
    cash_operation: "Кассалык операция",
    cashdesk: "Касса",
    cashier: "Кассир",
    cashier_inn: "Кассирдин ЖСТН",
    cashier_name: "Кассирдин аты",
    cashless_payment: "Накталай эмес төлөө",
    cashless_payments: "Накталай төлөмдөр",
    cheque: "Чек",
    cheque_generation_in_process_status_might_change_later: "Чекти түзүү жүрүп жатат. Статус өзгөрүшү үчүн бир аз убакыт талап кылынышы мүмкүн.",
    cheques: "Чектер",
    close_shift: "Нөөмөттү жабуу",
    closing_balance: "Күндүн аягына карата калдык",
    create_cheque: "Фискалдык чекти түзүү",
    dashboard: "Dashboard",
    data_is_invalid: "Дайындар жараксыз",
    data_is_valid: "Дайындар жарактуу",
    deposit_to_cashdesk: "Кассага акча салуу",
    enter_amount: "Сумманы киргизиңиз",
    enter_the_cheque_number: "Чектин номерин киргизиңиз",
    error_printing_cheque: "Чекти басып чыгаруу катасы",
    fiscal_cheque_copy_print: "Фискалдык текшерүү көчүрмөсүн басып чыгаруу",
    fiscal_cheque_print: "Фискалдык текшерүү",
    fiscal_device: "ККТ түзмөгү",
    fiscal_registrar: "Фискалдык каттоочу",
    fiscal_registrar_management: "Фискалдык каттоочу башкаруу",
    fixed: "Бекилген",
    injection: "Толтуруу",
    issue_an_advance: "Алдын ала чыгаруу",
    kkm_url: "Соода жабдуулары серверинин HTTP дареги. Эгерде ККМ сервери локалдык түрдө туташтырылбаса, толтуруу керек.",
    market_as_fiscal_cheque_manually: "Фискалдык чек катары кол менен белгилөө",
    name_of_service_in_cheque: "Чектеги кызматтын аталышы",
    not_subject_to_vat: "КНС салынбайт",
    only_for_payment_through_terminal: "ТТерминал аркылуу төлөө үчүн гана",
    open_shift: "Нөмөттү ачуу",
    opened_at: "Ачылыш күнү",
    opening_balance: "Күндүн башына карата баланс",
    partial_prepayment: "Жарым-жартылай алдын ала төлөө",
    print_totals: "Жыйынтыктарды басып чыгаруу",
    process_advances_as: "Алдын-ала төлөнгөн чектерди жүргүзүү",
    sale_of_goods: "Товарларды сатуу",
    sales: "Сатуулар",
    send_services_in_cheque: "Чектеги кызматтарды өткөрүп берүү",
    shift: "Нөмөт",
    shift_number: "Нөмөт номери",
    shifts: "Нөмөттөр",
    system_to_use: "Системаны колдонуу",
    terminal: "Терминал",
    totals: "Тоталдар",
    vat_rate: "КНС чени",
    waiting_for_payment_in_terminal: "Биз терминалдан төлөмдү күтүп жатабыз.",
    who_accepts_payment: "Төлөмдү ким кабыл алат",
    withdraw_from_cashdesk: "Кассадан кармап калуу",
    withdrawal: "Кармап калуу",
    withdrawal_replenishment_from_the_cash_register: "Кассадан толуктоону толуктоо",
    withdrawal_replenishment_of_cash: "Накталай акчаны алуу / толуктоо",
    xreport: "X-отчету",
    xreports: "X-отчеттору"
}
